import { render, staticRenderFns } from "./AssistantProfileComponent.vue?vue&type=template&id=17aa20e5&scoped=true"
import script from "./AssistantProfileComponent.vue?vue&type=script&lang=js"
export * from "./AssistantProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./AssistantProfileComponent.vue?vue&type=style&index=0&id=17aa20e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa20e5",
  null
  
)

export default component.exports